import React, { useEffect } from "react";
import {
  BetaForm as useBetaForm,
  TextInputBase,
  ButtonBase,
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  ModalBase,
} from "@reusejs/react";
import { MailIcon } from "@heroicons/react/outline";
import Link from "next/link";
import { newsletterSubscription } from "services";
import SuccessModalComponent from "../dashboard/profile/SuccessModal";

let sectionHeader = {
  title: "Sign up for Our Newsletter",
  description:
    "Stay up to date with the roadmap progress, announcements, and exclusive mega auction sale.",
};

const Actions = (props: any) => {
  return (
    <div className="max-w-lg m-auto">
      <TextInputBase
        name={"email"}
        onChange={(val) => props.form.setField("email", val)}
        placeholder={"Enter your email"}
        type={"text"}
        value={props.form.getField("email")}
        htmlFor={"email"}
        textInputBaseClasses={{
          padding: "pl-8",
        }}
        textInputPrefix={
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
            <MailIcon
              height="20"
              width="20"
              className="text-gray-500 font-semibold"
            />
          </div>
        }
        textInputSuffix={
          <div className="hidden md:block absolute -inset-y-0.5 right-0 flex items-center">
            <ButtonBase
              variant="primary"
              type="submit"
              label="Subscribe"
              onClick={() => {
                props.handleSubmitCb();
                console.log("BUTTON CLICKED");
              }}
              buttonBaseClasses={{
                font: "text-sm",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                borderRadius: "rounded-r-md",
                padding: "px-4 py-2.5",
              }}
            />
          </div>
        }
        error={
          props.form.errors.get("email") ? (
            <p className="mt-2 text-sm text-red-500">
              {props.form.errors.get("email")[0]}
            </p>
          ) : null
        }
      />
      <div className="block mt-3 lg:hidden">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Subscribe"
          onClick={() => {
            props.handleSubmitCb();
            console.log("BUTTON CLICKED");
          }}
          buttonBaseClasses={{
            width: "w-full",
            font: "text-sm",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            borderRadius: "rounded",
            padding: "px-4 py-2.5",
          }}
        />
      </div>
      <p className="mt-3 text-sm text-gray-500 text-start md:text-center">
        We care about the protection of your data. Read our{" "}
        <Link href="/privacypolicy">
          <a className="font-medium underline hover:text-blue-600">
            Privacy Policy.
          </a>
        </Link>
      </p>
    </div>
  );
};

export default function NewsLetterComponent() {
  const form = useBetaForm({
    email: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const SuccessModalWrapper = (props: any) => {
    return (
      <SuccessModalComponent
        heading="Subscription Successful"
        description="You have successfully subscribed to our newsletter."
        {...props}
      />
    );
  };

  const openModal = async () => {
    await ModalBase(
      {
        content: SuccessModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "z-50  overflow-visible",
          padding: "p-0",
          small: "max-w-4xl",
        },
      },
      1000,
      "__next"
    );
  };

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        const data: any = await newsletterSubscription(form.value);
        if (data) {
          openModal();
          form.setField("email", "");
        }
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
      }}
    >
      <IconTitleDescriptionActionCard
        title={sectionHeader.title}
        description={sectionHeader.description}
        actions={<Actions form={form} handleSubmitCb={handleSubmit} />}
        itemTitleDescriptionCardBaseClasses={{
          iconWrapper:
            "flex h-12 w-12 items-center justify-center rounded-md text-white",
          titleWrapper: "mt-2 text-start w-8/12 md:w-full md:text-center ",
          titleStyles: "text-2xl lg:text-3xl font-extrabold sm:text-4xl",
          descriptionWrapper:
            "text-start md:text-center mt-3 sm:mt-4 max-w-3xl mx-auto",
          descriptionStyles: "text-sm md:text-lg text-gray-500",
          actionWrapper: "mt-2 text-left",
        }}
      />
    </SectionContainerBase>
  );
}
